import create from '../create';
import common from './common';
export default function(sfc) {
  sfc.name = 'echart-' + sfc.name;
  sfc.mixins = sfc.mixins || [];
  sfc.mixins.push(common);
  return create(sfc);
}
